export default {
  title: "À deux c'est mieux",
  description: 'Un joli blog',
  thumbnail: 'accueil.jpeg',
  url: 'https://adeux-cestmieux.com',
};
